import axios from 'axios';
import React, { useState, useEffect } from 'react';

const UpdateAccount = ({ setIsEditFormVisible, fetchInfo, userData }) => {
  const [editFormData, setEditFormData] = useState({
    email: "",
    organisation: "",
    region: "",
    designation: "",
    userType: "",
    username: ""
  });

  useEffect(() => {
    if (userData) {
      setEditFormData({
        email: userData.email || "",
        organisation: userData.organisation || "",
        region: userData.region || "",
        designation: userData.designation || "",
        userType: userData.userType || "",
        username: userData.username || ""
      });
    }
  }, [userData]);

  return (
    <div className="bg-white border mx-8 mb-6 p-6 rounded-lg shadow">
      <h2 className="text-xl font-bold mb-4">Update Profile</h2>
      <div className="grid grid-cols-2 gap-4">
        <input
          type="text"
          value={editFormData.username}
          onChange={(e) =>
            setEditFormData({ ...editFormData, username: e.target.value })
          }
          className="border p-2 rounded"
          placeholder="Username"
        />
        <input
          type="text"
          value={editFormData.email}
          onChange={(e) =>
            setEditFormData({ ...editFormData, email: e.target.value })
          }
          className="border p-2 rounded"
          placeholder="Email"
        />
        <input
          type="text"
          value={editFormData.organisation}
          onChange={(e) =>
            setEditFormData({ ...editFormData, organisation: e.target.value })
          }
          className="border p-2 rounded"
          placeholder="Organisation"
        />
        <input
          type="text"
          value={editFormData.region}
          onChange={(e) =>
            setEditFormData({ ...editFormData, region: e.target.value })
          }
          className="border p-2 rounded"
          placeholder="Region"
        />
        <input
          type="text"
          value={editFormData.designation}
          onChange={(e) =>
            setEditFormData({ ...editFormData, designation: e.target.value })
          }
          className="border p-2 rounded"
          placeholder="Designation"
        />
        <input
          type="text"
          value={editFormData.userType}
          onChange={(e) =>
            setEditFormData({ ...editFormData, userType: e.target.value })
          }
          className="border p-2 rounded"
          placeholder="User Type"
        />
      </div>
      <div className="flex justify-end mt-4">
        <button
          className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600"
          onClick={async () => {
            try {
              const res = await axios.post(
                "https://api.confidanto.com/update-profile/update-user",
                editFormData
              );
              alert(res.data.message);
              setIsEditFormVisible(false);
              fetchInfo(); // refresh user data
            } catch (error) {
              console.error(error);
              alert("Failed to update profile.");
            }
          }}
        >
          Save Changes
        </button>
        <button
          className="ml-2 px-4 py-2 border border-gray-300 rounded"
          onClick={() => setIsEditFormVisible(false)}
        >
          Cancel
        </button>
      </div>
    </div>
  );
};

export default UpdateAccount;
